module.exports = __webpack_public_path__ + "img/183.2b937be1.jpg";